import { api } from "boot/axios";

export const currentLottery = async ({commit}) => {
  try {
    const resp = await api.get("/points/lottery/current/");
    resp.data.rewards = resp.data.rewards.sort( (a,b) => {
      if(a.position > b.position){
        return -1
      }
      if(a.position  < b.position){
        return 1
      }
      return 0
    })
    commit('setCurrentLottery', resp.data)
    return Promise.resolve(resp.data);
  } catch (error) {
    console.log(error);
    return Promise.reject(null);
  }
};


export const lastWinners = async () => {
  try {
    const resp = await api.get("/points/lottery/winners/last/");
    return Promise.resolve(resp.data);
  } catch (error) {
    console.log(error);
    return Promise.reject("");
  }
};

export const raffle = async ({dispatch}, {rewardId,lotteryId}) => {
  try {
    const resp = await api.post(`/points/lotteries/${lotteryId}/raffle/`,{
      reward: rewardId
    });
    await dispatch('currentLottery')
    return Promise.resolve(resp.data);
  } catch (error) {
    console.log(error);
    return Promise.reject("");
  }
};



export const updateIndexVideos = async () => {
  try {
    const resp = await api.get("/social/video/search/update/");
    return Promise.resolve(resp);
  } catch (error) {
    console.log(error);
    return Promise.reject("");
  }
};
